<script setup>
import { onMounted, reactive, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { spuLists } from '../api/index';
import moment from 'moment';

const router = useRouter();


const state = reactive({
    lists: [],
    total: 0,
    page: 1,
    pageSize: 10
});


// 获取列表
const getLists = () => {
    const data = {
        pageNo: state.page,
        pageSize: state.pageSize
    };
    spuLists(data).then(({ data }) => {
        const _data = data?.list || [];

        state.lists = _data;
        state.total = data.total;
        console.log(_data, 333);

    });
};

// 分页页数更改的时候
const handleCurrentChange = (val) => {
    state.page = val;
    getLists();
};


const { lists, detail, total, page } = toRefs(state);


onMounted(() => {

    getLists();

});


</script>

<template>
    <div class="wrap">
        <img class="banner" src="@/assets/imgs/update/wcsc.png" />
        <!--   列表     -->
        <ul>
            <li v-for="item in lists" :key="item.id">
                <router-link :to='"/cultural-creative/detail?id=" +item.id'>
                    <div class="img-box tc">
                        <img :src="item.picUrl">
                    </div>
                    <p class="tc line-clamp1">{{item.name}}</p>
                </router-link>
            </li>
        </ul>


        <el-pagination
            background
            layout="prev, pager, next"
            class="tc"
            prev-text="上一页"
            next-text="下一页"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :total="total">
        </el-pagination>

    </div>
</template>

<style scoped lang="scss">
.wrap{
    padding-bottom: 176px;
    ul{
        gap: 43px;
        flex-wrap: wrap;
        padding: 65px 46px;
        display: grid;
        grid-template-columns: repeat(4,1fr);
        margin-bottom: 148px;
        li{
            cursor: pointer;
            background: transparent;

            .img-box{
                width:100%;
                max-width: 419px;
                height:419px;

                img{
                    height: 100%;
                }

            }
            p{
                color:#16161a;
                font-size:24px;
                margin-top: 18px;
                max-width: 419px;
            }
        }
    }
}
.banner{
    width: 100%;
}
</style>
